/* ============================================================
   SOCIAL YIELD — Signal Engine
   Scroll-scrubbed Three.js story: NOISE → CAPTURE → SYNTHESIS → SIGNAL
   One glowing champagne path threads every scene.
   ============================================================ */
(function () {
  'use strict';

  var hero = document.getElementById('sy-hero');
  var canvas = document.getElementById('sy-canvas');
  if (!hero || !canvas) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function goStatic() {
    hero.classList.add('sy-hero--static');
    document.documentElement.classList.add('sy-static');
    window.__SY_READY = true;
  }

  if (reduced || typeof THREE === 'undefined') { goStatic(); return; }

  var renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
  } catch (e) { goStatic(); return; }
  if (!renderer.getContext()) { goStatic(); return; }

  /* ---------- config ---------- */
  var isMobile = window.innerWidth < 760;
  var DPR = Math.min(window.devicePixelRatio || 1, isMobile ? 2 : 1.75);
  var COUNT = isMobile ? 8000 : 16000;
  var DUST = isMobile ? 320 : 700;
  var LANES = 6;

  renderer.setPixelRatio(DPR);
  renderer.setClearColor(0x000000, 0);

  var scene = new THREE.Scene();
  scene.fog = new THREE.FogExp2(0x05080d, 0.0075);
  var camera = new THREE.PerspectiveCamera(46, 1, 0.1, 240);
  camera.position.set(0, 2, 46);

  /* ---------- deterministic rng ---------- */
  var seed = 1337;
  function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
  function gauss() { return (rnd() + rnd() + rnd() - 1.5) * 0.82; }

  /* ---------- palette ---------- */
  var C = {
    noiseA: new THREE.Color(0x2e3f57),
    noiseB: new THREE.Color(0x74869e),
    gold:   new THREE.Color(0xefdca6),
    goldLo: new THREE.Color(0xc9a96b),
    glacier:new THREE.Color(0x8fb6d9),
    silver: new THREE.Color(0xb9c4d2)
  };
  var laneTint = [
    new THREE.Color(0x5f86ad), /* linkedin */
    new THREE.Color(0xa9b2bf), /* x        */
    new THREE.Color(0x5a74b5), /* meta     */
    new THREE.Color(0xb06a63), /* youtube  */
    new THREE.Color(0xbd8a5c), /* reddit   */
    new THREE.Color(0x63a9a0)  /* tiktok   */
  ];

  /* ---------- particle attribute buffers ---------- */
  var chaos = new Float32Array(COUNT * 3);
  var stream = new Float32Array(COUNT * 3);
  var grid = new Float32Array(COUNT * 3);
  var orbit = new Float32Array(COUNT * 3);
  var colA = new Float32Array(COUNT * 3);
  var colB = new Float32Array(COUNT * 3);
  var laneC = new Float32Array(COUNT * 3);
  var aSeed = new Float32Array(COUNT);
  var aHi = new Float32Array(COUNT);

  var laneY = [7.6, 4.6, 1.6, -1.6, -4.6, -7.6];

  /* grid geometry */
  var G_COLS = 48, G_ROWS = 26;
  var G_X0 = 2.5, G_W = 28.5, G_Y0 = -8.2, G_H = 16.4;
  function sparkY(u) { return -6.4 + 13.2 * Math.pow(u, 1.35) + 0.9 * Math.sin(u * 8.2); }
  function arcY(u) { return -7.5 + 17 * Math.pow(u, 1.28) + 0.5 * Math.sin(u * 5.0); }
  var NODES = 12;

  var tmpA = new THREE.Color(), tmpB = new THREE.Color();

  for (var i = 0; i < COUNT; i++) {
    var i3 = i * 3;

    /* chaos: flattened ellipsoid cloud */
    var r = 7 + 19 * Math.pow(rnd(), 0.62);
    var th = rnd() * Math.PI * 2, ph = Math.acos(2 * rnd() - 1);
    chaos[i3]     = Math.sin(ph) * Math.cos(th) * r * 1.65;
    chaos[i3 + 1] = Math.cos(ph) * r * 0.92;
    chaos[i3 + 2] = Math.sin(ph) * Math.sin(th) * r * 1.1;

    /* streams: six braided lanes converging left → hub */
    var lane = i % LANES;
    var t = rnd();
    var conv = 1 - t * 0.5;
    stream[i3]     = -34 + 31 * t;
    stream[i3 + 1] = laneY[lane] * (1 - 0.28 * t) + Math.sin(t * 7 + lane * 1.7) * 0.8 * conv;
    stream[i3 + 2] = Math.cos(t * 5 + lane * 1.3) * 1.25 * conv + (lane - 2.5) * 0.45 * (1 - t);

    /* grid: signal LED wall + gold sparkline band */
    var cell = i % (G_COLS * G_ROWS);
    var cx = cell % G_COLS, cy = Math.floor(cell / G_COLS);
    var gx = G_X0 + (cx / (G_COLS - 1)) * G_W + (rnd() - 0.5) * 0.3;
    var gy = G_Y0 + (cy / (G_ROWS - 1)) * G_H + (rnd() - 0.5) * 0.3;
    var gu = (gx - G_X0) / G_W;
    var hi = Math.abs(gy - sparkY(gu)) < 0.42 ? 1 : 0;
    grid[i3] = gx; grid[i3 + 1] = gy; grid[i3 + 2] = (rnd() - 0.5) * 0.5;

    /* constellation: hi particles trace the arc, the rest cluster into 12 firm-nodes */
    if (hi) {
      var u = rnd();
      orbit[i3]     = -17 + 34 * u + (rnd() - 0.5) * 0.35;
      orbit[i3 + 1] = arcY(u) + (rnd() - 0.5) * 0.35;
      orbit[i3 + 2] = 0.5 + (rnd() - 0.5) * 0.35;
    } else {
      // soft rising bloom above the arc: outcome, not nodes
      var ub = rnd();
      orbit[i3]     = -19 + 38 * ub + gauss() * 1.3;
      orbit[i3 + 1] = arcY(ub) + 1.6 + Math.abs(gauss()) * 3.2;
      orbit[i3 + 2] = 0.4 + gauss() * 1.1;
    }

    /* colors */
    tmpA.copy(C.noiseA).lerp(C.noiseB, rnd());
    colA[i3] = tmpA.r; colA[i3 + 1] = tmpA.g; colA[i3 + 2] = tmpA.b;
    if (hi) { tmpB.copy(C.goldLo).lerp(C.gold, rnd()); }
    else    { tmpB.copy(C.glacier).lerp(C.silver, rnd() * 0.6); }
    colB[i3] = tmpB.r; colB[i3 + 1] = tmpB.g; colB[i3 + 2] = tmpB.b;
    var lt = laneTint[lane];
    laneC[i3] = lt.r; laneC[i3 + 1] = lt.g; laneC[i3 + 2] = lt.b;

    aSeed[i] = rnd() * 100;
    aHi[i] = hi;
  }

  var geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.BufferAttribute(chaos, 3));
  geo.setAttribute('aStream', new THREE.BufferAttribute(stream, 3));
  geo.setAttribute('aGrid', new THREE.BufferAttribute(grid, 3));
  geo.setAttribute('aOrbit', new THREE.BufferAttribute(orbit, 3));
  geo.setAttribute('aColA', new THREE.BufferAttribute(colA, 3));
  geo.setAttribute('aColB', new THREE.BufferAttribute(colB, 3));
  geo.setAttribute('aLane', new THREE.BufferAttribute(laneC, 3));
  geo.setAttribute('aSeed', new THREE.BufferAttribute(aSeed, 1));
  geo.setAttribute('aHi', new THREE.BufferAttribute(aHi, 1));

  var uniforms = {
    uProgress: { value: 0 },
    uTime: { value: 0 },
    uSize: { value: (isMobile ? 2.3 : 1.9) * DPR }
  };

  var pointsMat = new THREE.ShaderMaterial({
    uniforms: uniforms,
    transparent: true,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
    vertexShader: [
      'attribute vec3 aStream; attribute vec3 aGrid; attribute vec3 aOrbit;',
      'attribute vec3 aColA; attribute vec3 aColB; attribute vec3 aLane;',
      'attribute float aSeed; attribute float aHi;',
      'uniform float uProgress; uniform float uTime; uniform float uSize;',
      'varying vec3 vColA; varying vec3 vColB; varying vec3 vLane;',
      'varying float vE1; varying float vOrg; varying float vHi; varying float vFade;',
      'void main(){',
      '  float e1 = smoothstep(0.14, 0.38, uProgress);',
      '  float e2 = smoothstep(0.42, 0.64, uProgress);',
      '  float e3 = smoothstep(0.70, 0.88, uProgress);',
      '  vec3 p = mix(position, aStream, e1);',
      '  p = mix(p, aGrid, e2);',
      '  p = mix(p, aOrbit, e3);',
      '  float org = max(e2, e3);',
      '  float wob = mix(1.5, 0.09, max(e1 * 0.55, org));',
      '  p.x += sin(uTime * 0.6 + aSeed * 1.7) * wob * 0.62;',
      '  p.y += cos(uTime * 0.5 + aSeed * 2.3) * wob * 0.5;',
      '  p.z += sin(uTime * 0.7 + aSeed * 2.9) * wob * 0.5;',
      '  float flow = e1 * (1.0 - e2);',
      '  p.x += sin(uTime * 2.0 + aSeed * 4.1) * 0.28 * flow;',
      '  vec4 mv = modelViewMatrix * vec4(p, 1.0);',
      '  gl_Position = projectionMatrix * mv;',
      '  float sz = uSize * (0.75 + 0.75 * fract(aSeed * 7.31)) * (1.0 + aHi * (0.5 + org * 0.7));',
      '  sz *= mix(1.0, 0.62, org * (1.0 - aHi));',
      '  gl_PointSize = sz * (300.0 / -mv.z);',
      '  vColA = aColA; vColB = aColB; vLane = aLane;',
      '  vE1 = e1 * (1.0 - e2); vOrg = org; vHi = aHi;',
      '  vFade = 1.0 - smoothstep(0.88, 0.985, uProgress) * 0.9;',
      '}'
    ].join('\n'),
    fragmentShader: [
      'varying vec3 vColA; varying vec3 vColB; varying vec3 vLane;',
      'varying float vE1; varying float vOrg; varying float vHi; varying float vFade;',
      'void main(){',
      '  vec2 uv = gl_PointCoord - 0.5;',
      '  float d = length(uv);',
      '  float a = smoothstep(0.5, 0.06, d);',
      '  float damp = 1.0 - vOrg * (1.0 - vHi) * 0.8;',
      '  float hiTame = 1.0 - vHi * vOrg * 0.62;',
      '  vec3 col = mix(vColA, vLane, vE1 * 0.85);',
      '  col = mix(col, vColB, vOrg);',
      '  float glow = (0.55 + vOrg * 0.5 + vHi * 0.35) * damp * hiTame * vFade;',
      '  float alpha = a * (0.42 + 0.45 * vOrg + vHi * 0.12) * damp * hiTame * vFade;',
      '  gl_FragColor = vec4(col * glow, alpha);',
      '}'
    ].join('\n')
  });

  scene.add(new THREE.Points(geo, pointsMat));

  /* ---------- far dust for depth ---------- */
  var dustPos = new Float32Array(DUST * 3);
  for (var d = 0; d < DUST; d++) {
    dustPos[d * 3] = (rnd() - 0.5) * 160;
    dustPos[d * 3 + 1] = (rnd() - 0.5) * 90;
    dustPos[d * 3 + 2] = -30 - rnd() * 90;
  }
  var dustGeo = new THREE.BufferGeometry();
  dustGeo.setAttribute('position', new THREE.BufferAttribute(dustPos, 3));
  scene.add(new THREE.Points(dustGeo, new THREE.PointsMaterial({
    color: 0x3a4a63, size: 1.4 * DPR, sizeAttenuation: false,
    transparent: true, opacity: 0.5, depthWrite: false
  })));

  /* ---------- the gilded signal path ---------- */
  var pathPts = [
    new THREE.Vector3(-26, 7, 6),    new THREE.Vector3(-30, 0, -4),
    new THREE.Vector3(-22, -6, 3),   new THREE.Vector3(-17, 4, 1),
    new THREE.Vector3(-11, -2, -1),  new THREE.Vector3(-5, 1, 0),
    new THREE.Vector3(3, -4, 2),     new THREE.Vector3(11, 4, 1),
    new THREE.Vector3(19, -3, 2),    new THREE.Vector3(27, 3, 1),
    new THREE.Vector3(31, 6, 3),     new THREE.Vector3(14, 12, -5),
    new THREE.Vector3(-16, -6, 0.5), new THREE.Vector3(-8, -3.4, 0.5),
    new THREE.Vector3(0, 0, 0.5),    new THREE.Vector3(8, 3.6, 0.5),
    new THREE.Vector3(16, 7, 0.5),   new THREE.Vector3(19, 9.6, 0.5)
  ];
  var pathCurve = new THREE.CatmullRomCurve3(pathPts, false, 'catmullrom', 0.35);

  var sharedDraw = { value: 0 };
  var sharedGold = { value: new THREE.Color(0xefdca6) };

  function tubeShader(alphaMul) {
    return new THREE.ShaderMaterial({
      uniforms: { uDraw: sharedDraw, uTime: uniforms.uTime, uColor: sharedGold, uAlpha: { value: alphaMul } },
      transparent: true, depthWrite: false, blending: THREE.AdditiveBlending, side: THREE.DoubleSide,
      vertexShader: 'varying vec2 vUv; void main(){ vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }',
      fragmentShader: [
        'varying vec2 vUv;',
        'uniform float uDraw; uniform float uTime; uniform vec3 uColor; uniform float uAlpha;',
        'void main(){',
        '  if (vUv.x > uDraw) discard;',
        '  float head = smoothstep(uDraw - 0.02, uDraw, vUv.x) * 1.4;',
        '  float recent = mix(0.4, 1.0, smoothstep(uDraw - 0.45, uDraw, vUv.x));',
        '  float shimmer = 0.85 + 0.15 * sin(vUv.x * 90.0 - uTime * 2.2);',
        '  float birth = smoothstep(0.0, 0.05, vUv.x);',
        '  float i = (recent * shimmer + head) * birth;',
        '  gl_FragColor = vec4(uColor * i, i * uAlpha);',
        '}'
      ].join('\n')
    });
  }
  scene.add(new THREE.Mesh(new THREE.TubeGeometry(pathCurve, 420, 0.075, 8, false), tubeShader(0.9)));
  scene.add(new THREE.Mesh(new THREE.TubeGeometry(pathCurve, 420, 0.5, 8, false), tubeShader(0.08)));

  /* head glow sprite */
  var gcv = document.createElement('canvas'); gcv.width = gcv.height = 128;
  var gcx = gcv.getContext('2d');
  var grad = gcx.createRadialGradient(64, 64, 0, 64, 64, 64);
  grad.addColorStop(0, 'rgba(255,244,214,1)');
  grad.addColorStop(0.25, 'rgba(239,220,166,0.85)');
  grad.addColorStop(0.6, 'rgba(201,169,107,0.22)');
  grad.addColorStop(1, 'rgba(201,169,107,0)');
  gcx.fillStyle = grad; gcx.fillRect(0, 0, 128, 128);
  var headSprite = new THREE.Sprite(new THREE.SpriteMaterial({
    map: new THREE.CanvasTexture(gcv), transparent: true,
    blending: THREE.AdditiveBlending, depthWrite: false
  }));
  headSprite.scale.set(3.4, 3.4, 1);
  headSprite.visible = false;
  scene.add(headSprite);

  /* ---------- camera + look rails ---------- */
  var camCurve = new THREE.CatmullRomCurve3([
    new THREE.Vector3(0, 2, 46),  new THREE.Vector3(-15, 5, 30),
    new THREE.Vector3(-6, 1, 25), new THREE.Vector3(12, 2, 25),
    new THREE.Vector3(24, 4, 27), new THREE.Vector3(7, 6, 33),
    new THREE.Vector3(0, 3, 44)
  ], false, 'catmullrom', 0.4);
  var lookCurve = new THREE.CatmullRomCurve3([
    new THREE.Vector3(0, 0, 0),  new THREE.Vector3(-16, 1, 0),
    new THREE.Vector3(-5, 0, 0), new THREE.Vector3(10, 0, 0),
    new THREE.Vector3(22, 1, 1), new THREE.Vector3(2, 2, 0),
    new THREE.Vector3(0, 2.5, 0)
  ], false, 'catmullrom', 0.4);

  /* ---------- DOM refs ---------- */
  var intro = hero.querySelector('.sy-hero__intro');
  var cue = hero.querySelector('.sy-scroll-cue');
  var caps = Array.prototype.slice.call(hero.querySelectorAll('.sy-cap'));
  var finale = hero.querySelector('.sy-finale');
  var hud = hero.querySelector('.sy-hud');
  var hudFill = hero.querySelector('.sy-hud__fill');
  var hudDots = Array.prototype.slice.call(hero.querySelectorAll('.sy-hud__dot'));
  var scoreTick = hero.querySelector('.sy-score-tick');
  var scoreNum = hero.querySelector('.sy-score-tick b');
  var capRanges = [[0.075, 0.225], [0.245, 0.435], [0.455, 0.645], [0.665, 0.855]];
  var dotStops = [0.075, 0.30, 0.52, 0.74, 0.95];
  var SCORE_TARGET = parseInt(hero.getAttribute('data-score') || '82', 10);

  /* ---------- progress plumbing ---------- */
  var target = 0, prog = 0, lastShown = -1;
  var mouse = { x: 0, y: 0 }, par = { x: 0, y: 0 };
  var heroVisible = true;
  var camPos = new THREE.Vector3(), lookPos = new THREE.Vector3(), headPos = new THREE.Vector3();

  function smooth(a, b, x) { var t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); }

  function syncDom(p) {
    if (Math.abs(p - lastShown) < 0.0008) return;
    lastShown = p;
    var introOp = Math.max(0, 1 - p / 0.06);
    if (intro) { intro.style.opacity = introOp; intro.style.visibility = introOp <= 0.01 ? 'hidden' : 'visible'; }
    if (cue) cue.style.opacity = Math.max(0, 1 - p / 0.05);
    for (var c = 0; c < caps.length && c < capRanges.length; c++) {
      caps[c].classList.toggle('is-on', p >= capRanges[c][0] && p <= capRanges[c][1]);
    }
    if (finale) finale.classList.toggle('is-on', p > 0.9);
    if (hudFill) hudFill.style.height = (p * 100).toFixed(2) + '%';
    for (var h = 0; h < hudDots.length; h++) hudDots[h].classList.toggle('is-lit', p >= dotStops[h] - 0.004);
    if (hud) hud.style.opacity = p > 0.92 ? 0 : 1;
    if (scoreTick) {
      scoreTick.classList.toggle('is-on', p > 0.46);
      if (scoreNum) scoreNum.textContent = Math.round(SCORE_TARGET * smooth(0.46, 0.86, p));
    }
  }

  /* ---------- scroll binding ---------- */
  var track = hero.querySelector('.sy-hero__track');

  function nativeProgress() {
    var rect = hero.getBoundingClientRect();
    var total = hero.offsetHeight - window.innerHeight;
    if (total <= 0) return 0;
    return Math.min(1, Math.max(0, -rect.top / total));
  }

  if (window.gsap && window.ScrollTrigger && track) {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.create({
      trigger: hero,
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      onUpdate: function (self) { target = self.progress; }
    });
  } else {
    window.addEventListener('scroll', function () { target = nativeProgress(); }, { passive: true });
    target = nativeProgress();
  }

  /* ---------- pointer parallax ---------- */
  window.addEventListener('pointermove', function (e) {
    mouse.x = (e.clientX / window.innerWidth - 0.5) * 2;
    mouse.y = (e.clientY / window.innerHeight - 0.5) * 2;
  }, { passive: true });

  /* ---------- sizing ---------- */
  function resize() {
    var w = hero.clientWidth || window.innerWidth;
    var h = window.innerHeight;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }
  resize();
  window.addEventListener('resize', resize);

  /* ---------- visibility gating ---------- */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
    }, { rootMargin: '80px' }).observe(hero);
  }

  /* ---------- render loop ---------- */
  var clock = new THREE.Clock();
  function tick() {
    prog += (target - prog) * 0.08;
    if (Math.abs(target - prog) < 0.0004) prog = target;

    uniforms.uTime.value = clock.getElapsedTime();
    uniforms.uProgress.value = prog;

    var draw = smooth(0.09, 0.9, prog);
    sharedDraw.value = draw;
    if (draw > 0.005 && draw < 0.998) {
      headSprite.visible = true;
      pathCurve.getPointAt(Math.min(draw, 0.9999), headPos);
      headSprite.position.copy(headPos);
      var pulse = 1 + 0.14 * Math.sin(uniforms.uTime.value * 4.2);
      headSprite.scale.set(3.4 * pulse, 3.4 * pulse, 1);
    } else {
      headSprite.visible = false;
    }

    var cp = Math.min(prog, 0.9999);
    camCurve.getPointAt(cp, camPos);
    lookCurve.getPointAt(cp, lookPos);
    par.x += (mouse.x - par.x) * 0.04;
    par.y += (mouse.y - par.y) * 0.04;
    camera.position.set(camPos.x + par.x * 1.1, camPos.y - par.y * 0.8, camPos.z);
    camera.lookAt(lookPos);

    syncDom(prog);
    renderer.render(scene, camera);
    window.__SY_READY = true;
  }
  function frame() {
    requestAnimationFrame(frame);
    if (!heroVisible || document.hidden) return;
    tick();
  }
  frame();

  /* ---------- public API (debug / verification) ---------- */
  window.SYEngine = {
    get progress() { return prog; },
    seek: function (p, hard) {
      p = Math.min(1, Math.max(0, p));
      var total = hero.offsetHeight - window.innerHeight;
      var y = hero.offsetTop + total * p;
      if (window.__lenis) { window.__lenis.scrollTo(y, { immediate: true }); }
      else { window.scrollTo(0, y); }
      target = p;
      if (hard !== false) { prog = p; lastShown = -1; }
      if (window.ScrollTrigger) ScrollTrigger.update();
      target = p;
      tick();
    },
    renderNow: function () { tick(); }
  };
})();
